import { Text, View } from 'react-native'

function SectionHeader({ children }: { children: string }) {
  return (
    <View className={'bg-background-secondary px-4 pb-2 pt-5'}>
      <Text className={'text-sm text-text-secondary'}>{children}</Text>
    </View>
  )
}

export default SectionHeader
